import { Component, output } from '@angular/core';
import { DsButtonModule } from '@bmw-ds/components';

import { FoundRetailCustomer } from '../../../../customer/model/found-customer.model';
import { CustomerSearchContainer } from '../../../../customer-search-page/components/customer-search/customer-search.container';
import { SearchResultMode } from '../../../../form/components/search-results/model/search-result-mode.model';
import { SearchResultsContainer } from '../../../../form/components/search-results/search-results.container';

@Component({
  selector: 'cdf-add-customer-to-vehicle-search',
  imports: [DsButtonModule, CustomerSearchContainer, SearchResultsContainer],
  template: `
    <div class="px-4x pb-4x border-bottom">
      <cdf-customer-search-container hideVinSearch hideLicenseSearch fullWidth />
    </div>

    <div class="bg-page p-4x flex-grow-1">
      <cdf-search-results-container
        [searchResultMode]="searchResultMode"
        (openCustomerProfile)="selectCustomer.emit($event)"
      />
    </div>
  `,
  styleUrl: './add-customer-to-vehicle-search.container.scss',
})
export class AddCustomerToVehicleSearchContainer {
  readonly selectCustomer = output<FoundRetailCustomer>();

  protected readonly searchResultMode = SearchResultMode.C2V_LINK;
}
